import { mdiApi } from '@mdi/js'

export default [
  {
    title: 'تنظیمات تامین کننده',
    icon: mdiApi,
    action: 'can_see_menu_api_gift',
    resource: 'all',
    children: [
      {
        title: 'تنظیمات',
        to: 'api-setting',
        action: 'can_see_menu_api_gift',
        resource: 'all',
      },
      {
        title: 'کیف پول',
        to: 'api-wallet',
        action: 'can_see_menu_api_gift',
        resource: 'all',
      },
      {
        title: 'محصولات',
        to: 'api-products',
        action: 'can_see_menu_api_gift',
        resource: 'all',
      },
      {
        title: 'دسته بندی ها',
        to: 'api-categories',
        action: 'can_see_menu_api_gift',
        resource: 'all',
      },
      {
        title: 'صفحه logs',
        to: 'api-logs',
        action: 'can_see_menu_api_gift',
        resource: 'all',
      },
    ],
  },
]
